import React from 'react';
import NoPainImage from '../assets/images/NoPainImage.svg'
import MildPainImage from '../assets/images/MildPainImage.svg'
import ModeratePainImage from '../assets/images/ModeratePainImage.svg'
import SeverePainImage from '../assets/images/SeverePainImage.svg'
import NAImage from '../assets/images/NotApplicable.svg'

const joints = [
    "Left Hip",
    "Right Hip",
    "Left Knee",
    "Right Knee",
    "Left Ankle",
    "Right Ankle"
];

const painLevels = [
    { idSuffix: "NoPain", label: "No Pain", imgSrc: NoPainImage },
    { idSuffix: "MildPain", label: "Mild", imgSrc: MildPainImage },
    { idSuffix: "ModeratePain", label: "Moderate", imgSrc: ModeratePainImage},
    { idSuffix: "SeverePain", label: "Severe", imgSrc: SeverePainImage },
    { idSuffix: "NA", label: "Not applicable", imgSrc: NAImage }
];

const PainAssessment = ({selectedValue, prefix="", onChange}) => {

    const handleChange = (joint, painLevel) => {
        if(onChange) {
            onChange(joint, painLevel);
        }
    }
    // const formatText = (text) => {
    //     return text.toLowerCase().replace(/\s(.)/g, (_, char) => char.toUpperCase());
    // }
    const formatText = (text) => text.replace(/\s(.)/g, (_, char) => char.toUpperCase()).replace(/^\w/, c => c.toLowerCase());

    return (
        <div className="row wrapRow" style={{width:"65%"}}>
            {joints.map((joint, jointIndex) => (
                <div key={jointIndex} className="col" style={{margin:"1.5rem 2.5rem 1.5rem 0"}}>
                    <div>{joint}</div>
                    {painLevels.map((painLevel, painIndex) =>
                        (
                        <div key={painIndex} className="row formRadio">
                            <img src={painLevel.imgSrc} alt={painLevel.label} />
                            <input
                                id={`${prefix}${joint.replace(/\s+/g, "")}${painLevel.idSuffix}`}
                                // name={`${prefix}${joint.replace(/\s+/g, "").toLowerCase()}`}
                                name={`${prefix}${formatText(joint)}`}
                                type="radio"
                                //checked = {selectedValue[(formatText(joint)).trim()] === painLevel.label}
                                checked={selectedValue?.[formatText(joint)] === painLevel.label}
                                value={painLevel.label}
                                onChange={() => handleChange(formatText(joint), painLevel.label)}
                            />
                            <label
                             htmlFor={`${prefix}${joint.replace(/\s+/g, "")}${painLevel.idSuffix}`}
                            >
                                {painLevel.label}
                            </label>
                        </div>
                        )
                    )}
                </div>
            ))}
        </div>
    );
};

export default PainAssessment;
